import { logout } from "Store/features/authSlice";
import {
  clearRequestStatus,
  startRequest,
  submitRequestSuccess,
} from "Store/features/stateSlice";
import { REQUESTS, SERVER_URL } from "../../Util/constants";

const local = {
  puzzles: [
    {
      puzzle: {
        words: ["WILDLIFE", "HUMANS", "OVERLAP", "SPECIES"],
        grid: [
          ["V", "L", "F", "H", "U", "M", "A", "N", "S", "E"],
          ["O", "Q", "Y", "D", "S", "Q", "A", "D", "F", "Z"],
          ["C", "K", "S", "E", "I", "C", "E", "P", "S", "I"],
          ["U", "O", "Q", "A", "H", "B", "A", "Y", "Q", "Q"],
          ["B", "Y", "E", "F", "I", "L", "D", "L", "I", "W"],
          ["G", "P", "X", "U", "V", "V", "J", "I", "W", "L"],
          ["V", "Q", "G", "V", "O", "U", "I", "G", "S", "G"],
          ["T", "L", "F", "A", "U", "Q", "C", "J", "I", "U"],
          ["X", "O", "V", "E", "R", "L", "A", "P", "V", "M"],
          ["U", "F", "V", "E", "T", "E", "U", "C", "H", "N"],
        ],
      },
      org: "9d77d808-da36-4f66-ac47-c2b48a825d8b",
      lastEditDate: 1724309935870,
      creationDate: 1724309379779,
      id: "e2e8ac1f-69b1-4ad6-bcdd-458024040e07",
      type: "wordsearch",
      title: "Humans",
    },
    {
      puzzle: {
        takeawayPoints: [
          "AI chatbot running city government in Cheyenne, Wyoming",
          "Procreate CEO against generative AI in products",
          "Growing skepticism towards AI technology in companies",
          "Monogram offering preferred stock with 8% dividend yield",
          "President Biden passes torch to Kamala Harris at DNC",
          "7-Eleven parent company reviewing takeover bid from Canadian retailer",
          "Startup bankruptcies in the US on the rise",
        ],
        newsieInput: [
          [
            "AI",
            "Procreate",
            "Skepticism",
            "Monogram",
            "Biden",
            "7-Eleven",
            "Startup",
          ],
          [
            "Cheyenne",
            "CEO",
            "AI",
            "Preferred",
            "Kamala",
            "Takeover",
            "Bankruptcies",
          ],
          ["Wyoming", "AI", "Companies", "Stock", "DNC", "Canada", "Rise"],
        ],
      },
      org: "9d77d808-da36-4f66-ac47-c2b48a825d8b",
      creationDate: 1724297783800,
      lastEditDate: 1724297783800,
      id: "e8ad4331-1e9e-4467-98b2-6af0b8d06b80",
      type: "newsie",
    },
    {
      puzzle: {
        wordsAndClues: [
          {
            word: "BULWER-LYTTON",
            clue: "Contest for atrocious opening sentences",
          },
          {
            word: "INTEREST",
            clue: "Rates affecting home improvement sales",
          },
          {
            word: "GRAYSCALE",
            clue: "Investments in cryptocurrency",
          },
          {
            word: "PARAMOUNT",
            clue: "Entertainment company with suitor",
          },
          {
            word: "BAYESIAN",
            clue: "Yacht involved in shipwreck",
          },
          {
            word: "MONOGRAM",
            clue: "Offering preferred stock with dividend yield",
          },
          {
            word: "BACKYARD",
            clue: "Sports video game franchise",
          },
          {
            word: "GOLD",
            clue: "Value of a bar hits $1 million",
          },
          {
            word: "DISNEY",
            clue: "Reversal of wrongful death lawsuit decision",
          },
          {
            word: "PATAGONIA",
            clue: "Company giving day off for voting",
          },
        ],
        grid: [
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "G",
              clueNumber: 2,
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "P",
              clueNumber: 3,
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "R",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "A",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "M",
              clueNumber: 5,
              letter: "",
            },
            {
              answer: "O",
              letter: "",
            },
            {
              answer: "N",
              letter: "",
            },
            {
              answer: "O",
              letter: "",
            },
            {
              answer: "G",
              letter: "",
            },
            {
              answer: "R",
              letter: "",
            },
            {
              answer: "A",
              letter: "",
            },
            {
              answer: "M",
              letter: "",
            },
            {
              answer: "R",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "D",
              clueNumber: 7,
              letter: "",
            },
            {
              answer: "I",
              letter: "",
            },
            {
              answer: "S",
              letter: "",
            },
            {
              answer: "N",
              letter: "",
            },
            {
              answer: "E",
              letter: "",
            },
            {
              answer: "Y",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "A",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "S",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "M",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "C",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "O",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "B",
              clueNumber: 4,
              letter: "",
            },
            {
              answer: "A",
              letter: "",
            },
            {
              answer: "Y",
              letter: "",
            },
            {
              answer: "E",
              letter: "",
            },
            {
              answer: "S",
              letter: "",
            },
            {
              answer: "I",
              letter: "",
            },
            {
              answer: "A",
              letter: "",
            },
            {
              answer: "N",
              letter: "",
            },
            {
              answer: "U",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "G",
              clueNumber: 6,
              letter: "",
            },
            {
              answer: "O",
              letter: "",
            },
            {
              answer: "L",
              letter: "",
            },
            {
              answer: "D",
              letter: "",
            },
            {
              answer: "N",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "I",
              clueNumber: 1,
              letter: "",
            },
            {
              answer: "N",
              letter: "",
            },
            {
              answer: "T",
              letter: "",
            },
            {
              answer: "E",
              letter: "",
            },
            {
              answer: "R",
              letter: "",
            },
            {
              answer: "E",
              letter: "",
            },
            {
              answer: "S",
              letter: "",
            },
            {
              answer: "T",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
          [
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
            {
              answer: "",
              letter: "",
            },
          ],
        ],
        clues: {
          across: [
            {
              number: 1,
              position: {
                col: 2,
                row: 8,
              },
              word: "INTEREST",
              clue: "Rates affecting home improvement sales",
            },
            {
              number: 4,
              position: {
                col: 1,
                row: 6,
              },
              word: "BAYESIAN",
              clue: "Yacht involved in shipwreck",
            },
            {
              number: 5,
              position: {
                col: 1,
                row: 2,
              },
              word: "MONOGRAM",
              clue: "Offering preferred stock with dividend yield",
            },
            {
              number: 6,
              position: {
                col: 5,
                row: 7,
              },
              word: "GOLD",
              clue: "Value of a bar hits $1 million",
            },
            {
              number: 7,
              position: {
                col: 2,
                row: 3,
              },
              word: "DISNEY",
              clue: "Reversal of wrongful death lawsuit decision",
            },
          ],
          down: [
            {
              number: 2,
              position: {
                col: 7,
                row: 0,
              },
              word: "GRAYSCALE",
              clue: "Investments in cryptocurrency",
            },
            {
              number: 3,
              position: {
                col: 9,
                row: 0,
              },
              word: "PARAMOUNT",
              clue: "Entertainment company with suitor",
            },
          ],
        },
      },
      org: "9d77d808-da36-4f66-ac47-c2b48a825d8b",
      creationDate: 1724288370318,
      lastEditDate: 1724288370318,
      id: "c128b2b3-73dc-4ad6-b698-6f1161dbf4e9",
      type: "crossword",
    },
    {
      puzzle: {
        words: [
          "FINIMIZE",
          "PORTFOLIO",
          "COAL",
          "MERGER",
          "ENERGY",
          "STOCKS",
          "TAX",
        ],
        grid: [
          ["J", "S", "C", "N", "N", "L", "L", "Q", "V", "O"],
          ["F", "Y", "T", "J", "F", "H", "A", "V", "V", "I"],
          ["M", "I", "P", "O", "N", "V", "O", "V", "R", "L"],
          ["E", "N", "N", "I", "C", "D", "C", "H", "G", "O"],
          ["H", "N", "Z", "I", "A", "K", "L", "W", "Y", "F"],
          ["T", "M", "E", "T", "M", "P", "S", "I", "G", "T"],
          ["A", "A", "V", "R", "N", "I", "P", "D", "R", "R"],
          ["X", "K", "X", "J", "G", "D", "Z", "G", "Y", "O"],
          ["G", "V", "Q", "O", "B", "Y", "M", "E", "C", "P"],
          ["R", "E", "G", "R", "E", "M", "W", "U", "W", "E"],
        ],
      },
      org: "9d77d808-da36-4f66-ac47-c2b48a825d8b",
      creationDate: 1724367283839,
      lastEditDate: 1724367283839,
      id: "ce966d4c-f581-4e78-ae12-aa901fd4a9da",
      type: "wordsearch",
    },
  ],
};
const makeGetProfileRequest = async (dispatch, authToken) => {
  //   return local;
  dispatch(startRequest(REQUESTS.GET_PROFILE));
  let response;
  try {
    response = await fetch(`${SERVER_URL}/portal/profile`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": authToken,
      },
    });
    console.log({response})
    if (response.status === 401) {
        dispatch(logout());
        return;
    }
    
    dispatch(submitRequestSuccess(REQUESTS.DELETE_PROFILE));
  } catch (err) {
    console.log({ err });
    dispatch(logout())
  } finally {
    dispatch(clearRequestStatus(REQUESTS.DELETE_PROFILE));
  }
  return await response.json();
};

const makeDeleteProfileRequest = async (dispatch, authToken) => {
  dispatch(startRequest(REQUESTS.DELETE_PROFILE));

  const response = await fetch(`${SERVER_URL}/portal/profile`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "x-auth-token": authToken,
    },
  });
  dispatch(submitRequestSuccess(REQUESTS.DELETE_PROFILE));
  setTimeout(() => dispatch(clearRequestStatus(REQUESTS.DELETE_PROFILE)), 1000);
  return response.status;
};

const makeVerifyAccountEmailRequest = async (dispatch, emailToken) => {
  dispatch(startRequest(REQUESTS.VERIFY_ACCOUNT_EMAIL));

  const response = await fetch(`${SERVER_URL}/portal/profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
  dispatch(submitRequestSuccess(REQUESTS.VERIFY_ACCOUNT_EMAIL));
  setTimeout(() => dispatch(clearRequestStatus(REQUESTS.VERIFY_ACCOUNT_EMAIL)), 1000);
  return response.status;
};

export { makeGetProfileRequest, makeDeleteProfileRequest };
